import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";
// Tạo async thunk để lấy danh sách quà tặng dữ liệu từ API
export const getListRewardDataGw = createAsyncThunk(
  "rewardDataGw/getListRewardDataGw",
  async ({ currentPage, pageSize, type, status, selectedDates, search }, { rejectWithValue }) => {
    try {
      // Xây dựng query params
      let params = new URLSearchParams();
      
      // Thêm tham số phân trang
      params.append('page', currentPage);
      params.append('per_page', pageSize);
      
      
      if (type) {
        params.append('promotion_type', type);
      }
      
      if (status) {
        params.append('status', status);
      }

      // Thêm tham số tìm kiếm
      if (search) {
        params.append('search', search);
      }
      
      
      // Thêm params cho khoảng thời gian
      if (selectedDates && selectedDates.length === 2) {
        params.append('from_date', selectedDates[0]);
        params.append('to_date', selectedDates[1]);
      }

      // Gọi API với params
      const response = await http.get('/api/v1/serviceconnect/reward-data-gw/reward', { params });
      
      // Trả về dữ liệu từ API
      return response.data;
    } catch (error) {
      // Xử lý lỗi và trả về thông báo
      return rejectWithValue(error.response?.data?.message || "Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);


export const getSurveyResponsesList = createAsyncThunk(
  "rewardDataGw/getListResponsesw",
  async ({ surveyId, currentPage, pageSize, search,  selectedDates, giftStatus}, { rejectWithValue }) => {
    try {
      // Xây dựng query params
      let params = new URLSearchParams();
      
      // Thêm tham số phân trang
      params.append('page', currentPage);
      params.append('per_page', pageSize);
      
      // Thêm tham số tìm kiếm
      if (search) {
        params.append('search', search);
      }
      
      // Thêm params cho khoảng thời gian
      if (selectedDates && selectedDates.length === 2) {
        params.append('from_date', selectedDates[0]);
        params.append('to_date', selectedDates[1]);
      }

      if(giftStatus){
        params.append('gift_status', giftStatus);
      }

      // Gọi API với params
      const response = await http.get('/api/v1/serviceconnect/reward-data-gw/reward-data/'+surveyId, { params });
      
      // Trả về dữ liệu từ API
      return response.data;
    } catch (error) {
      // Xử lý lỗi và trả về thông báo
      return rejectWithValue(error.response?.data?.message || "Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);

export const sendRewardSurvey = createAsyncThunk(
  "rewardDataGw/sendRewardSurvey", 
  async ({ id }, { rejectWithValue }) => { 
    try {
      const response = await http.put(`/api/v1/serviceconnect//reward-data-gw/reward-data/${id}/send`);
      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);